<nav [ngClass]="{toTop :toTop == true }" class="sidebar d-flex flex-column  align-items-center">

    <ul class="rounded shadow-sm sidebar-menu py-2 w-100" >
        <li ><a [ngClass]="{menuActive :menuItem == 'profil' }" (click)=" menuItemFunction('profil')"   routerLink="/profil" >
            <img width="15" src="assets/Icones/Profil1.png" alt="">
            <span *ngIf="profilType === 'talent'" >Profils Talent</span>
            <span *ngIf="profilType === 'entrepise'">Profils Entreprise</span>
        </a>
    </li>
        <li *ngIf="profilType === 'entrepise'">
            <a [ngClass]="{menuActive :menuItem == 'creation' }" (click)="showProjectManagementSubmenu()" >
                <img width="15" src="assets/Icones/AppelsàCréation1.png" alt="">
                Appel à création</a>
            <ul [ngClass]="{active :projectManagementsubMenu == true }">
                <li>
                    <a  (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/add_challenge/" >
                    Soumettre un challenge</a>
                </li>
                <li><a (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/follow_challenge/">
                    Suivre mes challenges
                    </a>
                </li> 
            </ul>
        </li>
        <li *ngIf="profilType === 'talent'">
            <a [ngClass]="{menuActive :menuItem == 'creation' }" (click)="showProjectManagementSubmenu()" >
                <img width="15" src="assets/Icones/AppelsàCréation1.png" alt="">
                Appel à création</a>
            <ul [ngClass]="{active :projectManagementsubMenu == true }">
                <li>
                    <a  (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/inCourse/" >
                    challenge en cours</a>
                </li>
                <li><a (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/registered/">
                    challenge enregistrés
                    </a>
                </li>
                <li><a (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/manageProject/">
                   Gérez mes projets
                    </a>
                </li>
                <li><a (click)=" menuItemFunction('creation')" routerLinkActive="routerActive" routerLink="/project/gallery/">Galérie création</a></li>
            </ul>
        </li>
        <li >
            <a [ngClass]="{menuActive :menuItem == 'follow' }" (click)=" menuItemFunction('follow')" routerLink="/follow/list/">
            <img width="15" src="assets/Icones/Abonnements&Abonnés1.png" alt="">
            Abonnements & Followers
            </a>
        </li>
        <li *ngIf="profilType === 'entrepise'">
            <a [ngClass]="{menuActive :menuItem == 'recruiting' }"  (click)="showRecruitingSubMenu()" >
                <img width="15" src="assets/Icones/Recrutements1.png" alt="">
                <span *ngIf="profilType === 'entrepise'">Recruter</span>  </a>
                <ul [ngClass]="{active :recrutingSubMenu == true }"  >
                    <li>
                        <a (click)=" menuItemFunction('recruiting')" routerLinkActive="routerActive" routerLink="/recruit/submit_offer/" >
                        Soumettre une offre</a>
                    </li>
                    <li><a (click)=" menuItemFunction('recruiting')" routerLinkActive="routerActive" routerLink="/recruit/manage_application/">
                        Gérer les candidatures
                        </a>
                    </li> 
                </ul>
        </li>
        <li *ngIf="profilType === 'talent'">
            <a [ngClass]="{menuActive :menuItem == 'recruiting' }"  (click)="showRecruitingSubMenu()" >
                <img width="15" src="assets/Icones/Recrutements1.png" alt="">
                <span >Recrutements</span>  </a>
                <ul [ngClass]="{active :recrutingSubMenu == true }"  >
                    <li>
                        <a (click)=" menuItemFunction('recruiting')" routerLinkActive="routerActive" routerLink="/recruit/job_list/" >
                        Opportunités d'emploi</a>
                    </li>
                    <li><a (click)=" menuItemFunction('recruiting')" routerLinkActive="routerActive" routerLink="/recruit/my_application/">
                        Suivre mes candidatures
                        </a>
                    </li> 
                </ul>
        </li>
        <li *ngIf="profilType === 'talent'">
            <a>
                <img width="15" src="assets/Icones/EEYAAacademy1.png" alt="">
                EEYA academy
            </a>
        </li>
        <li  *ngIf="profilType === 'talent'">
            <a>
            <img width="15" src="assets/Icones/EspacePaiement1.png" alt="">
            Espace rémunération
            </a>
        </li>
        <li  *ngIf="profilType === 'entrepise'">
            <a>
            <img width="15" src="assets/Icones/EspacePaiement1.png" alt="">
            Espace paiement
            </a>
        </li>
        <li>
            <a>
                <img width="15" src="assets/Icones/Timeline1.png" alt="">
                Timeline
            </a>
        </li>  <li>
            <a>
                <img width="15" src="assets/Icones/Paramètres1.png" alt="">
                Paramètre
            </a>
        </li>
    </ul>
   
</nav>